import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import axios from "axios";
import { Spinner, Table, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UserDashboard = () => {
  const { user: currentUser } = useAuth();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    // Якщо користувач ще не підвантажений — нічого не робимо
    if (!currentUser?.id || !currentUser?.token) return;

    setLoading(true);
    setError(null);

    axios
      .get(`https://godrive.com.pl/api/user/reports/${currentUser.id}`, {
        headers: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      })
      .then((res) => {
        setReports(res.data);
      })
      .catch((err) => {
        console.error("Помилка при отриманні рапортів:", err);
        setError("Помилка при завантаженні рапортів.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentUser?.id, currentUser?.token]);

  // Поки ще не зʼявився currentUser — нічого не показуємо (React Suspense-стиль)
  if (!currentUser?.id || !currentUser?.token) {
    return <Spinner animation="border" variant="primary" className="m-4" />;
  }

  if (loading) {
    return <Spinner animation="border" variant="primary" className="m-4" />;
  }

  if (error) {
    return (
      <Alert variant="danger" className="m-4">
        {error}
      </Alert>
    );
  }

  return (
    <div className="container mt-4">
     

      {reports.length === 0 ? (
        <Alert variant="info" className="mt-3">
          {t("noReports")}
        </Alert>
      ) : (
        <Table striped bordered hover responsive className="mt-3">
          <thead>
            <tr>
              <th>{t("weekNumber")}</th>
              <th>{t("createdAt")}</th>
              <th>{t("actions")}</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((report) => (
              <tr key={report.id}>
                <td>{report.week_number}</td>
                <td>{new Date(report.created_at).toLocaleDateString()}</td>
                <td>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => navigate(`/user/report/${report.id}`)}
                  >
                    {t("viewreport")}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default UserDashboard;
